import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('EditTaskTemplateDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'resourceNameFilter',
    'close',
    'costResources',
    'parameterDefinitions',
    'mainTaskTemplateId',
    'taskTemplate',
    editTaskTemplateDialogCtrl,
  ]);

function editTaskTemplateDialogCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  resourceNameFilter,
  close,
  costResources,
  parameterDefinitions,
  mainTaskTemplateId,
  taskTemplate,
) {
  var vm = this;
  vm.showValidation = false;
  vm.taskTemplate = taskTemplate;
  vm.model = {
    costResourceId: taskTemplate.costResourceId,
    costParameterDefinitionId: taskTemplate.costParameterDefinitionId,
    costRegistrationUserId: taskTemplate.costRegistrationUserId,
  };
  vm.costResources = costResources;

  if (!vm.costResources) {
    resourceFactorySvc.get('resource').reg(
      {
        type: 1,
      },
      function(data) {
        vm.costResources = data
          .map(item => ({
            ...item,
            label: resourceNameFilter(item),
            code: item.code || '',
          }))
          .sort(dynamicSortMultiple('code', 'label'));
      },
    );
  }

  vm.onCostResourceChange = function() {
    if (!vm.model.costResourceId) {
      vm.model.costParameterDefinitionId = null;
      vm.model.costRegistrationUserId = null;
    }
  };

  vm.parameterDefinitions = parameterDefinitions;
  if (!vm.parameterDefinitions) {
    $http.get(`${appUrls.tasks}/api/TaskParameters/Definitions/${mainTaskTemplateId}`).then(
      function({ data }) {
        vm.parameterDefinitions = data.sort(dynamicSortMultiple('name'));
      },
      error => flySvc.error(error),
    );
  }

  vm.save = function() {
    if ($scope.form.$invalid) return;
    vm.saving = true;

    let model = angular.copy(taskTemplate);

    model.costResourceId = vm.model.costResourceId;
    model.costParameterDefinitionId = vm.model.costParameterDefinitionId;
    model.costRegistrationUserId = vm.model.costRegistrationUserId;

    delete model.assignedTo;
    delete model.mailTemplate;
    delete model.tags;

    $http.put(appUrls.tasks + '/api/tasktemplates/templates', model).then(
      function({ data = {} }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
        flySvc.success();

        taskTemplate.costResourceId = model.costResourceId;
        taskTemplate.costParameterDefinitionId = model.costParameterDefinitionId;
        taskTemplate.costRegistrationUserId = model.costRegistrationUserId;

        return false;
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
